import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20">
      <div className="relative">
        <span className="font-heading text-[7rem] md:text-[10rem] font-black text-primary-100 leading-none select-none">
          404
        </span>
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-16 h-16 rounded-2xl bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </span>
        </span>
      </div>
      <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-6">
        没有找到这个页面
      </h1>
      <p className="text-sm text-foreground-600 mt-2 font-mono">{location.pathname}</p>
      <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-md">
        页面可能已被移除或链接有误，你可以返回首页，或前往资讯与作品分类页继续浏览。
      </p>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-8">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-100 hover:bg-background-200 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          浏览作品库
        </Link>
      </div>
    </div>
  );
}